// @flow
import styled from "styled-components";
import {topHeaderBarHeight} from "../../../TopBar/TopBarStyle";
import {VerticalDelimeter} from "../../../AppStyle";


export const TerminalSelectionContainer = styled.div`
    top: ${topHeaderBarHeight};
    height: calc(100% - ${topHeaderBarHeight});
    width: 100%;
    position: fixed;
    background-color: #ffffff;
    padding-top: 25px;
    color: #555555;
    font-weight: 400;
    font-size: 17.5px;
    z-index: 1;
    
    > div {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
    }
`;

export const TerminalSelectionVerticalDelimiter = styled.div`
    ${VerticalDelimeter};
    background-color: #cccccc;
    max-height: 30px;
    min-height: 29px;
    min-width: 1px;
    max-width: 1px;
    margin-right: 10px;
    margin-left: 10px;
`;

export const AirportPolygonName = styled.label`
    font-size: 32.5px;
    margin: 0;
`;

export const TerminalSelectionTitle = styled.label`
    margin-top: 16.5px;
    margin-bottom: 11px;
`;

export const TerminalSelectionOptionsContainer = styled.div`
    display: block !important;
`;


// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/TerminalSelection/TerminalSelectionStyle.js